import React from "react";
import { LANDING } from "@/constants/testIds";

const FinalCta = ({ onClaim, spots = { total: 10, claimed: 0, remaining: 10 } }) => {
  const sold_out = spots.remaining <= 0;
  return (
    <section
      data-testid={LANDING.finalCtaSection}
      className="px-4 md:px-8 my-12 md:my-20"
    >
      <div className="bg-[#0A0A0A] text-white rounded-[2rem] md:rounded-[3rem] mx-auto max-w-7xl py-24 md:py-32 px-6 md:px-16 text-center relative overflow-hidden">
        <div className="pointer-events-none absolute -top-32 left-1/4 w-[480px] h-[480px] rounded-full bg-[#FF8200]/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 right-1/4 w-[480px] h-[480px] rounded-full bg-[#00B2A9]/20 blur-3xl" />

        <div className="relative max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white text-[11px] md:text-xs font-bold tracking-[0.2em] uppercase py-2.5 px-5 rounded-full mb-8">
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-[#FF8200] opacity-75 animate-ping" />
              <span className="relative inline-flex w-2 h-2 rounded-full bg-[#FF8200]" />
            </span>
            {sold_out
              ? "All 10 Spots Claimed — Waitlist Only"
              : `${spots.remaining} of ${spots.total} Spots Remaining`}
          </div>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.92]">
            The Spurs have home-court advantage. <br className="hidden md:block" />
            <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text">
              Now it's your turn.
            </span>
          </h2>
          <p className="mt-7 text-base md:text-lg text-zinc-300 leading-relaxed max-w-2xl mx-auto">
            Don't let your competitors score all the customers. If you're ready to turn
            Finals attention into more visibility, more customers, and more sales —
            claim your spot now.
          </p>
          <button
            type="button"
            onClick={onClaim}
            data-testid={LANDING.finalCta}
            className="mt-10 rounded-full bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-white font-bold px-10 py-5 text-base md:text-lg tracking-wider uppercase transition-all hover:opacity-95 hover:scale-[1.02] active:scale-[0.98] shadow-2xl shadow-[#EF426F]/30"
          >
            🏀 Claim My Finals Spot
          </button>
          <p className="mt-5 text-xs uppercase tracking-[0.25em] text-zinc-400">
            Stripe checkout · Instant confirmation
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
